import type { AnyShippingMethod } from "@jti/commerce";

const SINGLE_METHOD_MESSAGE_KEY_MAP: Record<AnyShippingMethod["type"], string> = {
  atHome: "cart.checkout.delivery_information.single.at_home",
  "in-store delivery": "cart.checkout.delivery_information.single.in_store",
  "custom delivery": "cart.checkout.delivery_information.single.parcel_point",
};

/**
 * Returns the translation key for the single-method informational message.
 */
export const getSingleMethodMessageKey = (type: AnyShippingMethod["type"]): string => {
  return SINGLE_METHOD_MESSAGE_KEY_MAP[type];
};
